import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import InputBox from 'src/components/shared/InputBox';
import SelectMenu from 'src/components/shared/SelectMenu';
import DatePicker from 'src/components/shared/DatePicker';
import { ExternalData } from 'src/utils/customInterface';
import { validationRules } from './validationRules';
import { checkErrorForm } from 'src/utils/ehrValidators';
const USStates: Array<ExternalData> = require('src/api/data/states.json');
import ProviderInfo, { ProviderInfoResponseStatusCode, ProviderInformationRequest, UploadFileRequestWithoutRegId } from 'src/models/provider';
import Clinic from 'src/models/clinic';
import { formatAndMaskSSN, parseDateToSendToServer } from 'src/utils/formater';
import Workflow from 'src/models/workflow';
import { ErrorMessageType, RegistrationStep, WorkflowContext, MaskPattern, FileTypes } from '../../utils/constValues';
import { getCurrentStepRouter, removeWorkflowContextData, setAttemptCounter, /*workflowFailUserExist*/ } from 'src/utils/workflow';
import { retryAllowed, /*getRetryTimes, workflowAllowedRetry,*/ workflowPermanentFail, clearSessionStorage } from 'src/utils/workflow';
import SelectMenuWithFreeText from '../shared/SelectMenuWithFreeText';
import { existNPI, existDEA } from 'src/api/provider';
import Facility from 'src/models/facility';
import PopupConfirm from 'src/components/shared/PopupConfirm';
import PopupWarning from 'src/components/shared/PopupWarning';
import { specialtiesList } from 'src/models/specialtyList';
import UploadFile from '../shared/FileUpload/UploadFile';
import { acscriptsAddress, reactGoogleAPIKey } from 'src/appconfig';
import { GeneralAddress, GoogleMapAPI } from 'src/utils/googleMapAPI';
import {  getUploadUrl, uploadToS3 } from 'src/api/s3Storage';
import VideoVerificationInfo from 'src/models/videoVerification';
// import VideoVerification from './DriverLicense/VideoVerification';
import FileUpload from '../shared/FileUpload';
import { getFileExtension } from 'src/utils/uploadFileUtility';
import { validationRulesNew } from './validationRulesNew';
import PopupMobileWarning from '../shared/PopupMobileWarning';
import { isMobileDevice } from 'src/utils/device';

export interface StateFromProps {
    loadingSpecialties: boolean;
    facilities: Array<Facility>;
    loadingFacilities: boolean;

    emailIsValid: boolean;
    saving: boolean;
    saved: boolean;

    workflow: Workflow;
    checkRetry: boolean;
    statusCode: number;
    errorMessage: string;
}

export interface DispatchFromProps {
    getFacilitiesByTenantNameAsync: (tenantName: string) => void;
    addProvider: (provider: ProviderInfo) => void;
    updateEmailIsValidStatus: () => void;
    updateWorkflow: (workflow: Workflow) => void;
    addProviderInformation: (providerInformation: ProviderInformationRequest) => void;
}

export type OwnProps = RouteComponentProps<{}>;

type Props = StateFromProps & DispatchFromProps & OwnProps;

export interface State {
    provider: ProviderInfo;
    providerInformation: ProviderInformationRequest;

    deaIsValid: boolean; // If dea exists => deaIsValid = false
    deaLoading: boolean; // show loading when checking exists dea
    triggerCheckDEA: boolean; // triggerCheckDEA = true => use to show the error message if dea exists
    npiIsValid: boolean; // If npi exists => npiIsValid = false
    npiLoading: boolean; // show loading when checking exists npi
    triggerCheckNPI: boolean; // triggerCheckNPI = true => use to show the error message if npi exists
    showDriverLicenseErrorMsg: boolean;
    showDuplicateAddressErrorMsg: boolean;

    emailPassed: boolean;
    hasError: boolean;
    hasErrorClinics: boolean;
    triggerCheckError: boolean;
    showErrorPopup: boolean;
    errorPopupType: string; // EXIST_USER_FACILITY, TERMINATED_NPI, or empty
    showWarningPopup: boolean;
    showMobileWarningPopup: boolean;
    hideSSN: boolean;

    newFile: UploadFile | undefined; // driver license
    googleMapsReady: boolean;
    isCleanOutAllInformation: boolean;
    resetKey: number;
    npiMask: string;
    phoneNumberMask: string;

    videoVerfication: VideoVerificationInfo;
    showConfirmPopupUploadVideoToS3: boolean;
    loadingUploadVideoToS3: boolean;

    hasErrorProviderInformation: boolean;
}
class Provider extends React.Component<Props, State> {
    private googleMapAPI: GoogleMapAPI;
    //private autocomplete: google.maps.places.Autocomplete | null = null;
    private videoBlobRef: Blob | null = null;

    constructor(props: Props) {
        super(props);
        window.document.title = 'Provider';
        this.state = this.state = this.getInitialState();
        this.googleMapAPI = new GoogleMapAPI();
    }

    getInitialState = (): State => {
        return {
            provider: this.initialProvider(),
            providerInformation: this.initialProviderInformation(),

            deaIsValid: false,
            deaLoading: false,
            triggerCheckDEA: false,
            npiIsValid: false,
            npiLoading: false,
            triggerCheckNPI: false,
            showDriverLicenseErrorMsg: false,
            showDuplicateAddressErrorMsg: false,

            emailPassed: true,
            hasError: checkErrorForm(validationRules, this.initialProvider()),
            hasErrorClinics: true,
            triggerCheckError: false,
            showErrorPopup: false,
            errorPopupType: '',
            showWarningPopup: false,
            showMobileWarningPopup: false,
            hideSSN: true,

            newFile: undefined,
            googleMapsReady: false,
            isCleanOutAllInformation: false,
            resetKey: 0,
            npiMask: '',
            phoneNumberMask: '',

            videoVerfication: {
                videoBlob: null,
                isUploaded: false,
                isError: false,
                messageInfo: ''
            },
            showConfirmPopupUploadVideoToS3: false,
            loadingUploadVideoToS3: false,
            hasErrorProviderInformation: checkErrorForm(validationRulesNew, this.initialProviderInformation())
        };
    }

    initialProvider = (): ProviderInfo => {
        let provider: ProviderInfo = {
            firstName: '',
            lastName: '',
            dob: '',
            specialty: '',
            clinicName: '',
            homeAddressLine1: '',
            homeCity: '',
            homeState: '',
            homeZipCode: '',
            homePhone: '',
            ssn: '',
            email: '',
            stateLicense: '',
            issuingState: '',
            expDate: '',
            dea: '',
            deaExpDate: '',
            degree: '',
            npi: '',
            taxId: '',

            clinics: [],
            uploadFile: {
                name: '',
                fileName: '',
                url: '',
                fileSize: 0
            },
            uploadVideo: {
                name: '',
                fileName: '',
                url: '',
                fileSize: 0
            }
        };

        return provider;
    }

    initialProviderInformation = (): ProviderInformationRequest => {
        let providerInformation: ProviderInformationRequest = {
            firstName: '',
            lastName: '',
            dob: '',
            specialty: '',
            homeAddressLine1: '',
            homeCity: '',
            homeState: '',
            homeZipCode: '',
            homePhone: '',
            ssn: '',
            email: '',
            degree: '',
            taxId: '',
            uploadFile: {
                name: '',
                fileName: '',
                url: '',
                fileSize: 0
            }
        };

        return providerInformation;
    }

    componentDidMount() {
        setAttemptCounter('0', true);
        //this.setState({ showWarningPopup: true });
        if (isMobileDevice()) {
            // Mobile
            this.setState({
                showMobileWarningPopup: true,
                showWarningPopup: false
            });
        } else {
            // Desktop / Laptop, normal flow
            this.setState({
                showWarningPopup: true,
                showMobileWarningPopup: false
            });
        }
 
        if (reactGoogleAPIKey && reactGoogleAPIKey!==''){
            this.googleMapAPI.loadGoogleMap(reactGoogleAPIKey, this.initAutocomplete);
        }
    }

    componentWillReceiveProps(nextProps: Props) {
        // With the latest workflow new users will login with loginId so email may be the same
        // if (this.props.emailIsValid && !nextProps.emailIsValid) {
        //     this.setState({ emailPassed: false });
        //     this.props.updateEmailIsValidStatus();
        // }

        // Currently, specialty list do not get from the server
        // if (this.props.loadingSpecialties !== nextProps.loadingSpecialties
        //     && !nextProps.loadingSpecialties) {
        //     this.setState({ showWarningPopup: true });
        // }

        if (this.props.saved !== nextProps.saved && nextProps.saved
            && nextProps.workflow.isCurrentStepFinished
            && nextProps.workflow.currentStep === RegistrationStep.ExperianQuestions) {
            // this.setState({ emailPassed: true });
            this.props.history.push(getCurrentStepRouter(nextProps.workflow));
        }

        if (this.props.checkRetry !== nextProps.checkRetry && nextProps.checkRetry) {
            if (nextProps.statusCode && nextProps.statusCode === ProviderInfoResponseStatusCode.Error_ExistUser) {
                // this.props.updateWorkflow(workflowFailUserExist());
                // clearSessionStorage();
                // this.props.history.push('/registration/existuser');
                this.setState({ showErrorPopup: true, errorPopupType: ErrorMessageType.EXIST_USER_FACILITY });
            }
            else if (nextProps.statusCode && (nextProps.statusCode === ProviderInfoResponseStatusCode.Error_TerminatedUser)) {
                // Do nothing
                // Show message indicator in saga
                this.setState({ showErrorPopup: true, errorPopupType: ErrorMessageType.TERMINATED_USER, isCleanOutAllInformation: true });
            }
            else if (nextProps.statusCode && (nextProps.statusCode === ProviderInfoResponseStatusCode.Error_General)) {
                this.setState({ showErrorPopup: true, errorPopupType: ErrorMessageType.GENERAL_ERROR, isCleanOutAllInformation: true });
            }
            else if (retryAllowed(true)) {
                // this.props.updateWorkflow(workflowAllowedRetry());
                // this.props.history.push('/registration/completewithfailallowedretry');              
                this.setState({ showErrorPopup: true, errorPopupType: '', isCleanOutAllInformation: true });
            }
            else {
                this.props.updateWorkflow(workflowPermanentFail());
                clearSessionStorage();
                this.props.history.push('/registration/completewithpermanentfail');
            }
        }
    }

    componentWillUnmount() {
        // Unload script to avoid multiple Google scripts loaded warning
        this.googleMapAPI.unloadGoogleMap();
    }

    handleChange = (value: string, field: string): void => {
        if (field === 'npi') {
            if (value && value != '' && value !== '__________') {
                this.setState({ npiMask: MaskPattern.NPI });
            }
            else {
                this.setState({ npiMask: '' });
            }
        }

        if (field === 'homePhone') {
            if (value && value != '' && value !== '(___) ___-____' && value !== '___) ___-____') {
                this.setState({ phoneNumberMask: MaskPattern.PHONE_NUMBER });
            }
            else {
                this.setState({ phoneNumberMask: '' });
            }
        }

        this.setState((prevState: State) => {
            const newProvider: ProviderInfo = {
                ...prevState.provider,
                [field]: value
            };
            const newProviderInformation: ProviderInformationRequest = {
                ...prevState.providerInformation,
                [field]: value
            };

            return {
                ...prevState,
                provider: newProvider,
                hasError: checkErrorForm(validationRules, { ...newProvider, ssn: formatAndMaskSSN(newProvider.ssn, false) }),
                providerInformation: newProviderInformation,
                hasErrorProviderInformation: checkErrorForm(validationRulesNew, { ...newProviderInformation, ssn: formatAndMaskSSN(newProvider.ssn, false) })
            };
        });
    }

    // Obsolete
    handleChange2 = (value: string, field: string): void => {
        this.setState((prevState: State) => {
            let maskUpdate: Partial<State> = {};
    
            switch (field) {
                case 'npi':
                    maskUpdate = { npiMask: value ? MaskPattern.NPI : '' };
                    break;
                case 'homePhone':
                    maskUpdate = { phoneNumberMask: value ? MaskPattern.PHONE_NUMBER : '' };
                    break;
                default:
                    break;
            }
    
            const newProvider: ProviderInfo = {
                ...prevState.provider,
                [field]: value,
            };
    
            return {
                ...prevState,
                ...maskUpdate,
                provider: newProvider,
                hasError: checkErrorForm(validationRules, { 
                    ...newProvider, 
                    ssn: formatAndMaskSSN(newProvider.ssn, false),
                }),
            };
        });
    }
    
    // Obsolete
    updateClinics = (clinics: Array<Clinic>, hasError: boolean): void => {
        const { provider } = this.state;
        provider.clinics = clinics;

        // Check duplicate clinic addresses
        let isExistDup = false;
        if (clinics && clinics.length > 1) {
            for (var i = 0; i < (clinics.length - 1); i++) {
                let compareCli = clinics[i];
                let compareArr = clinics.slice(i + 1);
                isExistDup = compareArr.some(e => e.addressLine1.trim().toLowerCase() === compareCli.addressLine1.trim().toLowerCase() &&
                    e.city.trim().toLowerCase() === compareCli.city.trim().toLowerCase() &&
                    e.state.trim().toLowerCase() === compareCli.state.trim().toLowerCase() &&
                    e.zipCode.trim().toLowerCase() === compareCli.zipCode.trim().toLowerCase());
                if (isExistDup) {
                    break;
                }
            }
        }

        this.setState({
            hasErrorClinics: hasError || isExistDup,
            provider: provider,
            showDuplicateAddressErrorMsg: isExistDup
        });
    }

    saveProvider = (): void => {
        const { hasError, hasErrorClinics, triggerCheckError, provider, newFile } = this.state;
        // if (!hasError && !npiLoading && npiIsValid && !deaLoading && deaIsValid) {
        if (!hasError && !hasErrorClinics && newFile && newFile.url) {
            if (provider.clinics.length > 0) {
                let requestInfo: ProviderInfo = { ...provider };
                requestInfo.dob = parseDateToSendToServer(provider.dob);
                requestInfo.expDate = parseDateToSendToServer(provider.expDate);
                requestInfo.deaExpDate = parseDateToSendToServer(provider.deaExpDate);
                requestInfo.uploadFile = {
                    name: newFile.name,
                    fileName: newFile.fileName,
                    description: newFile.description,
                    url: newFile.url,
                    fileSize: newFile.fileSize,
                } as UploadFileRequestWithoutRegId;
                this.props.addProvider(requestInfo);
            } else {
                alert('Please fill in the clinic address information!');
            }
        } else {
            this.setState({ triggerCheckError: !triggerCheckError });
            if (!newFile?.url) {
                this.setState({ showDriverLicenseErrorMsg: true });
            }
        }
    }

    // Used for provider information with video verification
    saveProvider_2 = (): void => {
        const { hasError, hasErrorClinics, triggerCheckError, provider, videoVerfication, newFile} = this.state;
        // if (!hasError && !npiLoading && npiIsValid && !deaLoading && deaIsValid) {
        if (!hasError && !hasErrorClinics && !videoVerfication.isError && videoVerfication.isUploaded && newFile && newFile.url) {
            if (provider.clinics.length > 0) {
                let requestInfo: ProviderInfo = { ...provider };
                requestInfo.dob = parseDateToSendToServer(provider.dob);
                requestInfo.expDate = parseDateToSendToServer(provider.expDate);
                requestInfo.deaExpDate = parseDateToSendToServer(provider.deaExpDate);
                requestInfo.uploadFile = {
                    name: newFile.name,
                    fileName: newFile.fileName,
                    description: newFile.description,
                    url: newFile.url,
                    fileSize: newFile.fileSize,
                } as UploadFileRequestWithoutRegId;
                console.log('requestInfo: ', requestInfo);
                this.props.addProvider(requestInfo);
            } else {
                alert('Please fill in the clinic address information!');
            }
        } else {
            this.setState({ triggerCheckError: !triggerCheckError });
            if (!this.videoBlobRef || !videoVerfication.videoBlob) {
                this.setState((prevState) => ({
                    videoVerfication: {
                        ...prevState.videoVerfication,
                        isError: true,
                        messageInfo: 'Video verification required !\nPlease record and upload video verification to continue.'
                    }
                }));
            }
            if (videoVerfication.videoBlob && !videoVerfication.isUploaded) {
                this.setState((prevState) => ({
                    videoVerfication: {
                        ...prevState.videoVerfication,
                        isError: true,
                        messageInfo: `Video verification not uploaded !\nPlease click Upload Video to complete video verification.`
                    }
                }));
            }
            if (!newFile?.url) {
                this.setState({ showDriverLicenseErrorMsg: true });
            }
        }
    }

    saveProviderInformation = (): void => {
        const { hasErrorProviderInformation, triggerCheckError, providerInformation, newFile } = this.state;
        if (!hasErrorProviderInformation && newFile && newFile.url) {
                let requestInfo: ProviderInformationRequest = { ...providerInformation };
                requestInfo.dob = parseDateToSendToServer(providerInformation.dob);
                requestInfo.uploadFile = {
                    name: newFile.name,
                    fileName: newFile.fileName,
                    description: newFile.description,
                    url: newFile.url,
                    fileSize: newFile.fileSize,
                } as UploadFileRequestWithoutRegId;

                // Call new step01
                this.props.addProviderInformation(requestInfo);
        } else {
            this.setState({ triggerCheckError: !triggerCheckError });
            if (!newFile?.url) {
                this.setState({ showDriverLicenseErrorMsg: true });
            }
        }
    }

    // Obsolete
    // Check exist NPI
    onBlurNPI = async (): Promise<void> => {
        const { provider, triggerCheckNPI } = this.state;
        let errorNPI = checkErrorForm({ npi: validationRules.npi }, { npi: provider.npi });
        if (!errorNPI) {
            this.setState({ npiLoading: true, npiIsValid: false, triggerCheckNPI: true });
            let exist = await existNPI(provider.npi);
            if (exist) {
                this.setState({ npiLoading: false, npiIsValid: false });
            }
            else {
                this.setState({ npiLoading: false, npiIsValid: true });
            }
        }
        else if (triggerCheckNPI) {
            this.setState({ triggerCheckNPI: false });
        }
    }

    // Obsolete
    // Check exist DEA
    onBlurDEA = async (): Promise<void> => {
        const { provider, triggerCheckDEA } = this.state;
        let errorDEA = checkErrorForm({ dea: validationRules.dea }, { dea: provider.dea });
        if (!errorDEA) {
            this.setState({ deaLoading: true, deaIsValid: false, triggerCheckDEA: true });
            let exist = await existDEA(provider.dea);
            if (exist) {
                this.setState({ deaLoading: false, deaIsValid: false });
            }
            else {
                this.setState({ deaLoading: false, deaIsValid: true });
            }
        }
        else if (triggerCheckDEA) {
            this.setState({ triggerCheckDEA: false });
        }
    }

    closeErrorPopup = (): void => {
        this.setState({ showErrorPopup: false });

        const { isCleanOutAllInformation } = this.state;
        if (isCleanOutAllInformation) {
            this.cleanOutAllInformations();
        }
    }

    closeWarningPopup = (): void => {
        this.setState({ showWarningPopup: false });
    }

    handleChangeSSN = (value: string, field: string): void => {
        const { hideSSN, provider } = this.state;

        if (value.replace(/-/g, '').length < provider.ssn.length) {
            const last = provider.ssn.length - 1;

            let ssn = provider.ssn.slice(0, last);
            this.handleChange(ssn, field);

            return;
        }

        let ssnNumberValue = value.replace(/\D/g, '');

        let newSSN = '';
        if (hideSSN) {
            // Because have prefix ***-**-xxxx
            if (provider.ssn.length > 5) {
                newSSN = provider.ssn.slice(0, 5) + ssnNumberValue;
            }
            else {
                newSSN = provider.ssn + ssnNumberValue;
            }
        }
        else {
            newSSN = ssnNumberValue;
        }

        if (newSSN.length > 9) {
            return;
        }

        this.handleChange(newSSN, field);
    }

    showHideSSN = (): void => {
        const { hideSSN } = this.state;
        this.setState({
            hideSSN: !hideSSN
        });
    }

    // Upload files
    addFile = (file: UploadFile): void => {
        file.createdDate = new Date().toString();
        this.setState({
            newFile: file,
            showDriverLicenseErrorMsg: false
        });
    }

    removeFile = (): void => {
        this.setState({
            newFile: undefined
        });
    }

    initAutocomplete = () => {
        // console.log('Init Autocomplete for provider address starts');
        // const {provider} = this.state;
        // if (provider){
        //     console.log('initAutocomplete');
        //     const homeAddress1InputId= `txtHomeAddress`;
        //     this.googleMapAPI.initAutocomplete(homeAddress1InputId, this.autocomplete, (place, generalAddress) => this.handleProviderAddressSelected(generalAddress));
        // }
    }
    
    handleProviderAddressSelected = ({ addressLine1, city, state, zipCode }: GeneralAddress) => {
        this.setState((prevState) => ({
            provider: {
                ...prevState.provider,
                homeAddressLine1: addressLine1,
                homeCity: city,
                homeState: state,
                homeZipCode: zipCode,
            },
        }));
    }

    initAutocompleteClinicAddress = () => {
        // if (this.state.provider.clinics.length === 0){
        //     let index = 0;
        //     const clnicAddress1InputId= `txtClinicAddress-${index}`;
        //     this.googleMapAPI.initAutocomplete(clnicAddress1InputId, (place, generalAddress) => this.handleClinicAddressSelected(generalAddress, index));
        // }

        // console.log('Init Autocomplete clinic address starts');
        // var { clinics } = this.state.provider;

        // clinics.length > 0 && clinics.map((clinic, clinicIndex) => {
        //     const clnicAddress1InputId= `txtClinicAddress-${clinicIndex}`;
        //     this.googleMapAPI.initAutocomplete(clnicAddress1InputId, this.autocomplete, (place, generalAddress) => this.handleClinicAddressSelected(generalAddress, clinicIndex));
        // });
    }

    handleClinicAddressSelected = (
        { addressLine1, city, state, zipCode }: GeneralAddress,
        clinicIndex: number
    ) => {
        this.setState((prevState) => {
            const updatedClinics = prevState.provider.clinics.map((item, index) => {
                if (index === clinicIndex) {
                    return {
                        ...item,
                        addressLine1,
                        city,
                        state,
                        zipCode,
                    };
                }
                return item;
            });
    
            return {
                provider: {
                    ...prevState.provider,
                    clinics: updatedClinics,
                },
            };
        });
    }
    cleanOutAllInformations = () => {
        removeWorkflowContextData(WorkflowContext.WorkFlowData);
        clearSessionStorage();
        this.props.history.push('/registration/provider');

        this.setState({
            provider: this.initialProvider(),
            isCleanOutAllInformation: false,
            resetKey: this.state.resetKey + 1, // Change key to force remount of ClinicAddress

            deaIsValid: false,
            deaLoading: false,
            triggerCheckDEA: false,
            npiIsValid: false,
            npiLoading: false,
            triggerCheckNPI: false,
            showDriverLicenseErrorMsg: false,
            showDuplicateAddressErrorMsg: false,
            emailPassed: true,
            hasError: false,
            hasErrorClinics: true,
            triggerCheckError: false,
            showErrorPopup: false,
            errorPopupType: '',
            hideSSN: true,
            newFile: undefined,

            videoVerfication: {
                videoBlob: null,
                isUploaded: false,
                isError: false,
                messageInfo: ''
            },
            providerInformation: this.initialProviderInformation(),
            hasErrorProviderInformation: false
        }
        );

        if (isMobileDevice()) {
            // Mobile
            this.setState({
                showMobileWarningPopup: true,
                showWarningPopup: false
            });
        } else {
            // Desktop / Laptop, normal flow
            this.setState({
                showWarningPopup: true,
                showMobileWarningPopup: false
            });
        }
    }

    handleVideoVerificationChange = (videoBlob: Blob | null): void => {
        this.videoBlobRef = videoBlob;

        if (videoBlob) {
            this.setState((prevState) => ({
                videoVerfication: {
                    videoBlob: videoBlob,
                    isError: false,
                    isUploaded: false,
                    messageInfo: ''
                }
            }));

        } else {
            console.log('No video blob provided');
        }
    }

    handleVideoVerificationMessageUpdate = (message: string, isErrorMessage: boolean): void => {
        this.setState((prevState) => ({
            videoVerfication: {
                ...prevState.videoVerfication,
                isError: isErrorMessage,
                messageInfo: message
            }
        }));
    }

    handleVideoVerificationStopReplaying = (): void => {
        this.setState((prevState) => ({
            videoVerfication: {
                ...prevState.videoVerfication,
                videoBlob: null,
                isUploaded: false
            }
        }));
    }

    openConfirmPopupUploadToS3 = () : void => {
        this.setState({
            showConfirmPopupUploadVideoToS3: true
        });
    }

    onCancelConfirmPopupUploadVideoToS3 = (): void => {
        this.setState({
            showConfirmPopupUploadVideoToS3: false
        });
    }

    handleUploadVideoToS3 = async () => {
        const { videoVerfication } = this.state;

        if (!videoVerfication || !videoVerfication.videoBlob) {
            return;
        }

        this.setState({ loadingUploadVideoToS3: true });

        try {
            // 1. Get pre-signed URL
            const { preSignedUrl, fileKey, fileName } = await getUploadUrl(videoVerfication.videoBlob.type) || {};

            if (!preSignedUrl || !fileKey || !fileName) {
                return;
            }

            // 2. Use pre-signed URL to upload recored video to S3 
            const updatedVideoFile = new File([videoVerfication.videoBlob], fileName, { type: videoVerfication.videoBlob.type });

            const { isSuccess, errorMessage } = await uploadToS3(preSignedUrl, updatedVideoFile);

            this.setState((prevState) => ({
                videoVerfication: {
                    ...prevState.videoVerfication,
                    isError: !isSuccess,
                    messageInfo: isSuccess ? 'Video verification uploaded successfully.\nPlease continue registration.' : errorMessage,
                    isUploaded: isSuccess ? true : false
                }
            }));

            const uploadedVideo: UploadFileRequestWithoutRegId = {
                name: fileName,
                fileName,
                url: fileKey,
                fileSize: videoVerfication.videoBlob.size,
                description: '',
            };

            this.setState(prevState => ({
                provider: {
                    ...prevState.provider,
                    uploadVideo: uploadedVideo
                }
            }));
        } catch (error) {
            console.log('Failed to upload video:', error);
        } finally {
            this.setState({
                showConfirmPopupUploadVideoToS3: false,
                loadingUploadVideoToS3: false,
            });
        }
    }

    render() {
        const { loadingSpecialties, saving, errorMessage } = this.props;

        const { 
            triggerCheckError, 
            showErrorPopup, 
            errorPopupType, 
            showWarningPopup,
            showMobileWarningPopup, 
            provider,
            hideSSN,
            phoneNumberMask
            /*npiLoading, npiIsValid, triggerCheckNPI, deaLoading, deaIsValid, triggerCheckDEA*/
        } = this.state;

        // const {videoVerfication, showConfirmPopupUploadVideoToS3, loadingUploadVideoToS3} = this.state;
        const {newFile, showDriverLicenseErrorMsg} = this.state;

        const homeAddressRegex = validationRulesNew.homeAddressLine1.format;
        const isProviderHomeAddressInvalid = provider.homeAddressLine1 && !homeAddressRegex.test(provider.homeAddressLine1);

        const homeCityRegex = validationRulesNew.homeCity.format;
        const isProviderHomeCityInvalid = provider.homeCity && !homeCityRegex.test(provider.homeCity);

        return (
            <main>
                <div className="tab-content tabs-style">
                    <div className="tab-pane h-100 fade show active" role="tabpanel">
                        <div className="flex-full">
                            <div className="fix-workspace flex-full">
                                <div className="tab-content wrapper-lv-4">
                                    <div className="tab-pane h-100 fade show active" role="tabpanel">
                                        <div className="row no-gutters pl-1 pr-1 h-100">
                                            <div className="col main-cont">
                                                <div className="flex-full card-sp">
                                                    <h5 className="card-title-sp">Provider Information</h5>
                                                    <div className="card-cont-sp flex-full">
                                                        <div className="fix-workspace">
                                                            <div className="autoscroll-1 border-cont">
                                                                {
                                                                    loadingSpecialties || saving ?
                                                                        <div className="loading-center">
                                                                            <table className="table table-borderless">
                                                                                <tbody className="spinner-bg d-flex">
                                                                                    <tr className="text-center">
                                                                                        <td className="alert alert-info" role="alert">
                                                                                            <span className="alert-text"><span className="spinner-border text-info spinner-border-md float-right" role="status" aria-hidden="true" />{saving ? 'Submitting...' : 'Loading...'}</span>
                                                                                        </td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                        :
                                                                        <form autoComplete="off">
                                                                            {/* <div className="form-group">
                                                                                <label className="col-form-label">1. For ID Verification purposes, please click here to record 20 seconds video of you are holding your legal ID driver license above shoulder level. After recording, review the video and click the <b>Upload Video</b> button to upload your video verification</label>
                                                                                <br />
                                                                                <div className="d-flex justify-content-center">
                                                                                    <div className="col-auto col-4">
                                                                                        <div className={!videoVerfication.isError && videoVerfication.isUploaded ? 'recorder-disabled' : ''}>
                                                                                            <VideoVerification
                                                                                                onVideoVerificationChange={this.handleVideoVerificationChange}
                                                                                                onVideoVerificationStopReplaying={this.handleVideoVerificationStopReplaying}
                                                                                                onVideoVerificationMessageUpdate={this.handleVideoVerificationMessageUpdate}
                                                                                            />
                                                                                        </div>
                                                                                        <div className="d-flex justify-content-between mt-3">
                                                                                            <div>
                                                                                            {(videoVerfication.messageInfo && (
                                                                                                <div className={videoVerfication.isError ? 'text-danger' : 'text-success'}>
                                                                                                    {videoVerfication.messageInfo.split('\n').map((item, index) => (
                                                                                                        <React.Fragment key={index}>
                                                                                                            {item}
                                                                                                            <br />
                                                                                                        </React.Fragment>
                                                                                                    ))}
                                                                                                </div>
                                                                                            ))}
                                                                                            </div>
                                                                                            <div>
                                                                                                <button
                                                                                                    className="btn btn-sm btn-light"
                                                                                                    type="button"
                                                                                                    onClick={this.openConfirmPopupUploadToS3}
                                                                                                    disabled={!videoVerfication || !videoVerfication.videoBlob || videoVerfication.isUploaded}
                                                                                                >
                                                                                                    <i className="fa fa-upload" /> Upload Video
                                                                                                </button>
                                                                                            </div>
                                                                                        </div>
                                                                                        <PopupConfirm
                                                                                            showPopup={showConfirmPopupUploadVideoToS3}
                                                                                            confirmMessage={`Are you sure you want to upload this video for verification?\nOnce uploaded, it will be used as part of your registration process and cannot be changed.`}
                                                                                            loading={loadingUploadVideoToS3}
                                                                                            loadingMessage={'Uploading...'}
                                                                                            onCancel={this.onCancelConfirmPopupUploadVideoToS3}
                                                                                            executeFunction={this.handleUploadVideoToS3}
                                                                                            customTextYesButton={'Yes'}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div> */}
                                                                            <div className="form-group row">
                                                                                <label className="col-sm-3 col-form-label">1. Account #</label>
                                                                                <div className="col-auto col-sm-2">
                                                                                    <input type="text" className="form-control width220" value="N/A" disabled={true} />
                                                                                </div>
                                                                            </div>
                                                                            <div className="form-group row">
                                                                                <label className="col-sm-3 col-form-label">2. User #</label>
                                                                                <div className="col-auto col-sm-2">
                                                                                    <input type="text" className="form-control width220" value="N/A" disabled={true} />
                                                                                </div>
                                                                            </div>
                                                                            <div className="form-group row">
                                                                                <label className="col-sm-3 col-form-label">3. Provider Name <span className="required-icon">*</span></label>
                                                                                <div className="col-auto">
                                                                                    <InputBox
                                                                                        id="txtProviderName"
                                                                                        extendClass={['', 'width220']}
                                                                                        field="firstName"
                                                                                        label="First Name"
                                                                                        value={provider.firstName}
                                                                                        placeHolder={`First Name`}
                                                                                        rules={validationRulesNew.firstName}
                                                                                        onChange={this.handleChange}
                                                                                        triggerCheckError={triggerCheckError}
                                                                                        triggerClearError={false}
                                                                                        autoComplete="new-password"  // Use a unique value to prevent browser autofill
                                                                                    />
                                                                                </div>
                                                                                <div className="col-auto">
                                                                                    <InputBox
                                                                                        id="txtProviderName"
                                                                                        extendClass={['', 'width220']}
                                                                                        field="lastName"
                                                                                        label="Last Name"
                                                                                        value={provider.lastName}
                                                                                        placeHolder={`Last Name`}
                                                                                        rules={validationRulesNew.lastName}
                                                                                        onChange={this.handleChange}
                                                                                        triggerCheckError={triggerCheckError}
                                                                                        triggerClearError={false}
                                                                                        autoComplete="new-password"  // Use a unique value to prevent browser autofill
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            <div className="form-group row">
                                                                                <label className="col-sm-3 col-form-label" htmlFor="ipProviderDOB">4. Provider Date of Birth <span className="required-icon">*</span></label>
                                                                                <div className="col-auto col-sm-2">
                                                                                    <DatePicker
                                                                                        id="ipProviderDOB"
                                                                                        extendClass="width125"
                                                                                        field="dob"
                                                                                        label="Date of Birth"
                                                                                        value={provider.dob}
                                                                                        rules={validationRulesNew.dob}
                                                                                        onChange={this.handleChange}
                                                                                        triggerCheckError={triggerCheckError}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            <div className="form-group row">
                                                                                <label className="col-sm-3 col-form-label" htmlFor="txtHomeAddress">5. Provider Home Address <span className="required-icon">*</span></label>
                                                                                <div className="col-auto">
                                                                                    <InputBox
                                                                                        id="txtHomeAddress"
                                                                                        extendClass={['', 'width350']}
                                                                                        field="homeAddressLine1"
                                                                                        label="Home Address"
                                                                                        value={provider.homeAddressLine1}
                                                                                        rules={validationRulesNew.homeAddressLine1}
                                                                                        onChange={this.handleChange}
                                                                                        triggerCheckError={triggerCheckError}
                                                                                        triggerClearError={false}
                                                                                        autoComplete="new-password"  // Use a unique value to prevent browser autofill
                                                                                    />                                                                               
                                                                                </div>
                                                                                <label className="col-auto col-form-label" htmlFor="txtHomeCity">City</label>
                                                                                <div className="col-auto">
                                                                                    <InputBox
                                                                                        id="txtHomeCity"
                                                                                        extendClass={['', 'width115']}
                                                                                        field="homeCity"
                                                                                        label="City"
                                                                                        value={provider.homeCity}
                                                                                        rules={validationRulesNew.homeCity}
                                                                                        onChange={this.handleChange}
                                                                                        triggerCheckError={triggerCheckError}
                                                                                        triggerClearError={false}
                                                                                        autoComplete="new-password"  // Use a unique value to prevent browser autofill
                                                                                    />
                                                                                </div>
                                                                                <label className="col-auto col-form-label" htmlFor="sbHomeState">State</label>
                                                                                <div className="col-auto">
                                                                                    <SelectMenu
                                                                                        id="sbHomeState"
                                                                                        extendClass={['', 'width115']}
                                                                                        field="homeState"
                                                                                        label="State"
                                                                                        value={provider.homeState}
                                                                                        rules={validationRulesNew.homeState}
                                                                                        onChange={this.handleChange}
                                                                                        triggerCheckError={triggerCheckError}
                                                                                        triggerClearError={false}
                                                                                        autoComplete="new-password"  // Use a unique value to prevent browser autofill
                                                                                    >
                                                                                        <option value="">SELECT</option>
                                                                                        {USStates.map(state => <option key={state.code} value={state.code}>{state.name}</option>)}
                                                                                    </SelectMenu>
                                                                                </div>
                                                                                <label className="col-auto col-form-label" htmlFor="txtHomeZipcode">Zip Code</label>
                                                                                <div className="col-auto">
                                                                                    <InputBox
                                                                                        id="txtHomeZipcode"
                                                                                        extendClass={['', 'width75']}
                                                                                        field="homeZipCode"
                                                                                        label="ZipCode"
                                                                                        value={provider.homeZipCode}
                                                                                        rules={validationRulesNew.homeZipCode}
                                                                                        onChange={this.handleChange}
                                                                                        triggerCheckError={triggerCheckError}
                                                                                        triggerClearError={false}
                                                                                        autoComplete="new-password"  // Use a unique value to prevent browser autofill
                                                                                    />
                                                                                </div> 
                                                                            </div>
                                                                            {isProviderHomeAddressInvalid && (
                                                                                <div className="form-group row">
                                                                                    <label className="col-sm-3 col-form-label" />
                                                                                    <div className="col-auto">
                                                                                        <div className="text-danger mt-1 small">
                                                                                            Address contains invalid characters.
                                                                                            Please use letters, numbers, spaces, and symbols only
                                                                                            <strong> (# - ' $ / .)</strong>.
                                                                                            Maximum 40 characters.
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                            {isProviderHomeCityInvalid && (
                                                                                <div className="form-group row">
                                                                                    <label className="col-sm-3 col-form-label" />
                                                                                    <div className="col-auto">
                                                                                        <div className="text-danger mt-1 small">
                                                                                            City contains invalid characters.
                                                                                            Please use letters, spaces, and symbols only
                                                                                            <strong> (. – ')</strong>.
                                                                                            Maximum 35 characters.
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                            <div className="form-group row">
                                                                                <label className="col-sm-3 col-form-label" htmlFor="txtHomePhone">6. Provider Personal Phone Number <span className="required-icon">*</span></label>
                                                                                <div className="col-auto col-sm-2">
                                                                                    <InputBox
                                                                                        id="txtHomePhone"
                                                                                        extendClass={['width125', 'width125']}
                                                                                        field="homePhone"
                                                                                        label="Personal Phone"
                                                                                        rules={validationRulesNew.homePhone}
                                                                                        value={provider.homePhone}
                                                                                        placeHolder="(xxx) xxx-xxxx"
                                                                                        mask={phoneNumberMask}
                                                                                        onChange={this.handleChange}
                                                                                        triggerCheckError={triggerCheckError}
                                                                                        triggerClearError={false}
                                                                                        autoComplete="new-password"  // Use a unique value to prevent browser autofill
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            <div className="form-group row">
                                                                                <label className="col-sm-3 col-form-label" htmlFor="txtSSN">7. Provider SSN <span className="required-icon">*</span></label>
                                                                                <div className="col-auto col-sm-2 d-flex">
                                                                                    <InputBox
                                                                                        id="txtSSN"
                                                                                        extendClass={['width125', 'width125']}
                                                                                        field="ssn"
                                                                                        label="SSN"
                                                                                        rules={validationRulesNew.ssn}
                                                                                        value={formatAndMaskSSN(provider.ssn, hideSSN)}
                                                                                        placeHolder="xxx-xx-xxxx"
                                                                                        onChange={this.handleChangeSSN}
                                                                                        triggerCheckError={triggerCheckError}
                                                                                        triggerClearError={false}
                                                                                        autoComplete="new-password"  // Use a unique value to prevent browser autofill
                                                                                    />
                                                                                    <span
                                                                                        data-toggle="tooltip"
                                                                                        data-placement="right"
                                                                                        title={hideSSN ? 'Show SSN' : 'Hide SSN'}
                                                                                        style={{
                                                                                            marginTop: '3px',
                                                                                            marginLeft: '10px',
                                                                                            cursor: 'pointer'
                                                                                        }}
                                                                                    >
                                                                                        <i className={hideSSN ? 'fa fa-eye' : 'fa fa-eye-slash'} onClick={this.showHideSSN} />
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                            <div className="form-group row">
                                                                                <label className="col-sm-3 col-form-label" htmlFor="txtEmail">8. Provider Email <span className="required-icon">*</span></label>
                                                                                <div className="col-auto col-sm-2">
                                                                                    <InputBox
                                                                                        id="txtEmail"
                                                                                        // extendClass={emailPassed ? ['width350', 'width350'] : ['width350 has-error', 'width350']}
                                                                                        extendClass={['width350', 'width350']}
                                                                                        field="email"
                                                                                        label="Email"
                                                                                        value={provider.email}
                                                                                        rules={validationRulesNew.email}
                                                                                        onChange={this.handleChange}
                                                                                        triggerCheckError={triggerCheckError}
                                                                                        triggerClearError={false}
                                                                                        autoComplete="new-password"  // Use a unique value to prevent browser autofill
                                                                                    // errorMessage={emailPassed ? '' : 'This email has been used!'}
                                                                                    // onKeyPress={() => !emailIsValid ? this.setState({ emailPassed: true }) : {}}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            <div className="form-group row">
                                                                                <label className="col-sm-3 col-form-label" htmlFor="txtProviderSpecialty">9. Provider Specialty <span className="required-icon">*</span></label>
                                                                                <div className="col-auto col-sm-2">
                                                                                    <SelectMenu
                                                                                        id="txtProviderSpecialty"
                                                                                        extendClass={['width350', 'width350']}
                                                                                        field="specialty"
                                                                                        label="Provider Specialty"
                                                                                        value={provider.specialty}
                                                                                        rules={validationRulesNew.specialty}
                                                                                        onChange={this.handleChange}
                                                                                        triggerCheckError={triggerCheckError}
                                                                                        triggerClearError={false}
                                                                                        autoComplete="new-password"  // Use a unique value to prevent browser autofill
                                                                                    >
                                                                                        <option value="">SELECT</option>
                                                                                        {specialtiesList.map(item => <option key={item.value} value={item.value}>{item.value}</option>)}
                                                                                    </SelectMenu>
                                                                                </div>
                                                                            </div>
                                                                            <div className="form-group row">
                                                                                <label className="col-sm-3 col-form-label" htmlFor="sbProviderDegree">10. Provider Degree <span className="required-icon">*</span></label>
                                                                                <div className="col-auto">
                                                                                    <SelectMenuWithFreeText
                                                                                        id="sbProviderDegree"
                                                                                        extendClass={['', 'width125']}
                                                                                        field="degree"
                                                                                        label="Provider Degree"
                                                                                        value={provider.degree}
                                                                                        rules={validationRulesNew.degree}
                                                                                        onChange={this.handleChange}
                                                                                        triggerCheckError={triggerCheckError}
                                                                                        triggerClearError={false}
                                                                                    >
                                                                                        <option>DO</option>
                                                                                        <option>MD</option>
                                                                                        <option>NP</option>
                                                                                        <option>DNP</option>
                                                                                        <option>DMD</option>
                                                                                        <option>DDS</option>
                                                                                        <option>PA</option>
                                                                                        <option>DPM</option>
                                                                                        <option>PharmD</option>
                                                                                    </SelectMenuWithFreeText>
                                                                                </div>
                                                                            </div>
                                                                            {/* <div className="form-group row">
                                                                                <label className="col-sm-3 col-form-label" htmlFor="txtDriverLicenseNo">11. Driver License #<span className="required-icon">*</span></label>
                                                                                <div className="col-auto">
                                                                                    <InputBox
                                                                                        id="txtDriverLicenseNumber"
                                                                                        extendClass={['', 'width125']}
                                                                                        field="driverLicenseNumber"
                                                                                        label="Driver License Number"
                                                                                        value={provider.driverLicenseNumber}
                                                                                        rules={validationRulesNew.driverLicenseNumber}
                                                                                        onChange={this.handleChange}
                                                                                        triggerCheckError={triggerCheckError}
                                                                                        triggerClearError={false}
                                                                                        autoComplete="new-password"  // Use a unique value to prevent browser autofill
                                                                                    />
                                                                                </div>
                                                                                <label className="col-auto col-form-label" htmlFor="sbDriverLicenseState">Issuing State <span className="required-icon">*</span></label>
                                                                                <div className="col-auto">
                                                                                    <SelectMenu
                                                                                        id="sbDriverLicenseState"
                                                                                        extendClass={['', 'width115']}
                                                                                        field="driverLicenseState"
                                                                                        label="Issuing State"
                                                                                        value={provider.driverLicenseState}
                                                                                        rules={validationRulesNew.driverLicenseState}
                                                                                        onChange={this.handleChange}
                                                                                        triggerCheckError={triggerCheckError}
                                                                                        triggerClearError={false}
                                                                                        autoComplete="new-password"  // Use a unique value to prevent browser autofill
                                                                                    >
                                                                                        <option value="">SELECT</option>
                                                                                        {USStates.map(state => <option key={state.code} value={state.code}>{state.name}</option>)}
                                                                                    </SelectMenu>
                                                                                </div>
                                                                            </div> */}
                                                                            <div className="form-group row">
                                                                                <label className="col-sm-12 col-form-label">11. For ID Verification purposes, please upload a selfie of you holding your legal ID (driver license or passport) <span className="required-icon">*</span></label>
                                                                                <span className="col-sm-12 col-form-label">
                                                                                    Supported formats: .JPG, .JPEG, .PNG, .PDF, .GIF
                                                                                </span>
                                                                            </div>
                                                                            <div className="form-group row">
                                                                                <label className="col-sm-3 col-form-label" />
                                                                                <div className="row align-items-start" style={{ gap: '20px' }}>
                                                                                <div className="col-auto upload-column">
                                                                                    <div 
                                                                                        className={`file-upload-box ${newFile ? 'has-image' : ''}`}
                                                                                        // style={{width: newFile ? 'auto': '220px'}}
                                                                                    >
                                                                                    <FileUpload
                                                                                        files={newFile ? [newFile] : []}
                                                                                        fileSizeMB={10}
                                                                                        totalfileSizesMB={10}
                                                                                        fileTypes={[FileTypes.JPG, FileTypes.PNG, FileTypes.PDF, FileTypes.GIF, FileTypes.DOC, FileTypes.DOCX]}
                                                                                        addFile={(file: UploadFile) => this.addFile(file)}
                                                                                        removeFile={() => this.removeFile()}
                                                                                        hiddenListFile={true}
                                                                                        disabled={!!newFile}
                                                                                        textButton="Browse"
                                                                                        icon={<i className="fa fa-paperclip" />}
                                                                                    />
                                                                                    {
                                                                                        showDriverLicenseErrorMsg &&
                                                                                        <p style={{ color: 'red', marginTop: 5 }}>Please upload your photo of yourself holding your driver’s license. This field is required.</p>
                                                                                    }
                                                                                    <div className="img-frame" style={{ marginTop: 10 }}>
                                                                                        {
                                                                                            newFile &&
                                                                                            <button type="button" className="btn btn-sm remove-file-button" onClick={this.removeFile}>
                                                                                                <i className="fa fa-times" />
                                                                                            </button>
                                                                                        }
                                                                                        {
                                                                                            !newFile ? '' :
                                                                                                ['.jpg', '.jpeg', '.png'].includes(getFileExtension(newFile.fileName).toLowerCase()) ?
                                                                                                    // tslint:disable-next-line:jsx-alignment
                                                                                                    <img src={`${acscriptsAddress.Registration_API}/${newFile.url}`}
                                                                                                        // tslint:disable-next-line:jsx-alignment
                                                                                                        style={{ maxHeight: '200px' }} />
                                                                                                    :
                                                                                                    <h6 style={{ textAlign: 'center' }}> Previewer does not support this file type </h6>
                                                                                        }
                                                                                    </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-auto">
                                                                                    <img 
                                                                                        src={`/imgs/user2-holding-id.png`}
                                                                                        style={{ maxHeight: '220px', maxWidth: '220px' }}
                                                                                        alt="Example of a person holding a verification photo"
                                                                                    />
                                                                                </div>
                                                                                </div>
                                                                            </div>
                                                                        </form>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="main-btn-group d-flex align-items-center">
                                    <button className="btn btn-sm btn-light" type="submit" onClick={this.saveProviderInformation} disabled={saving}><i className="fa fa-arrow-right" /> Next</button>                           
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <PopupConfirm
                    showPopup={showErrorPopup}
                    shouldHideNoButton={true}
                    customTextYesButton={' OK'}
                    stepOneMessage={errorMessage}
                    loading={false}
                    inStepOne={true}
                    stepOneType={errorPopupType}
                    onCancel={() => { }}
                    executeFunction={this.closeErrorPopup}
                />
                <PopupWarning
                    showPopup={showWarningPopup}
                    shouldHideNoButton={true}
                    customTextYesButton={' OK'}
                    loading={false}
                    onCancel={() => { }}
                    executeFunction={this.closeWarningPopup}
                />
                <PopupMobileWarning
                    showPopup={showMobileWarningPopup}
                    onClose={() => {
                        this.setState({ showMobileWarningPopup: false });
                    }}
                />
            </main>
        );
    }
}

export default Provider;


// WEBPACK FOOTER //
// ./src/components/Provider/Provider.tsx